import React from 'react';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { menuItemStyle, menuListStyle, menuPaperStyle } from '../OptionsMenu.style';
export const MenuContent = ({ dataQa, id, actions, isOpened, anchorEl, setAnchorEl }) => {
    const handleClose = (event, action) => {
        action && action.action(id);
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
    };
    return (React.createElement(Menu, { elevation: 0, "data-qa": `${dataQa}-actionMenu`, open: isOpened, onClose: (event) => handleClose(event), PaperProps: { sx: menuPaperStyle }, MenuListProps: { sx: menuListStyle }, anchorEl: anchorEl, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" } }, Array.isArray(actions) &&
        actions.length > 0 &&
        actions.map((action, i) => {
            return (React.createElement(MenuItem, { key: `menuItem-${i}`, onClick: (event) => handleClose(event, action), "data-qa": `${dataQa}-actionMenuItem`, sx: menuItemStyle },
                action.icon,
                action.title));
        })));
};
